import { Observable } from 'rxjs'
import { Customer, Address, PageableSearch, DisplayOrder } from "../../models"
import { Query } from "../../services"
import { CustomerActions } from './customer.actions';
export interface CustomersState {
	address: Address
	customer: Customer
	customerSearch: PageableSearch<Customer>
	displayOrders: DisplayOrder[],
	showDisplayOrderSpinner: boolean
};

const initialState: CustomersState  = {
	customer: null,
	address: null,
	customerSearch: {
		content: [],
		first: false,
		last: false,
		number: 0,
		numberOfElements: 0,
		size: 0,
		totalElements: 0,
		totalPages: 0
	},
	displayOrders: null,
	showDisplayOrderSpinner: false,
}


export const customersReducer = (state = initialState, action): CustomersState => {
	switch (action.type) {
		case CustomerActions.ADDRESS_SAVED:
		case CustomerActions.CUSTOMER_LOADED: {
			return Object.assign({}, state,
				{
					customer: action.payload
				})
		}
		case CustomerActions.CUSTOMER_SEARCH_SUCCESS: {
			return Object.assign({}, state,
				{
					customerSearch: action.payload
				})
		}

		case CustomerActions.SET_ADDRESS_FOR_EDIT: {
			return Object.assign({}, state, {
				address: action.payload
			})
		}

		case CustomerActions.LOAD_DISPLAY_ORDERS_BY_CUSTOMER_UUID: {
			return Object.assign({}, state,
				{
					displayOrders: null,
					showDisplayOrderSpinner: true
				})
		}

		case CustomerActions.DISPLAY_ORDERS_LOADED: {
			return Object.assign({}, state,
				{
					displayOrders: action.payload,
					showDisplayOrderSpinner: false
				})
		}
		case CustomerActions.INIT_CUSTOMER_FROM_QUERY: {
			let customer: Customer = new Customer;
			customer.firstname = action.payload.firstname
			customer.city = action.payload.city
			customer.companyName = action.payload.company
			customer.email = action.payload.email
			customer.lastname = action.payload.lastname
			customer.postalCode = action.payload.postalCode
			customer.street = action.payload.street
			return Object.assign({}, state, {customer: customer})
		}

		default: return state;
	}

}


/*export function getCustomers() {
	return (state$: Observable<CustomersState>) => state$.map(s => s.customer);

}*/
/*export function findCustomerByUuid(uuid: string) {
	return (state$: Observable<CustomersState>) => state$
		.let(getCustomers())
		.map(customers => customers.find(c => c.uuid === uuid))
}*/



// WEBPACK FOOTER //
// ./src/app/components/customer-management/customer.reducer.ts